module.exports = __webpack_public_path__ + "img/blog-2.5d5c7795.jpg";